import React from 'react';
import { Outlet } from 'react-router-dom';

const CampaignRoutes: React.FC = () => {
  return <Outlet />;
};

export default CampaignRoutes;